import prevIcon from "../../assets/ui/prev.png";
import nextIcon from "../../assets/ui/next.png";
import './styles/gallery.pagination.css';

function GalleryPagination({ page, setPage, total }) {
  return (
    <div className="pagination">
      <img
        src={prevIcon}
        className={`nav-btn ${page === 0 ? "disabled" : ""}`}
        onClick={() => page > 0 && setPage(page - 1)}
        alt="이전"
      />

      {Array.from({ length: total }).map((_, i) => (
        <span
          key={i}
          className={`dot ${page === i ? "active" : ""}`}
          onClick={() => setPage(i)}
        />
      ))}

      <img
        src={nextIcon}
        className={`nav-btn ${page === total - 1 ? "disabled" : ""}`}
        onClick={() => page < total - 1 && setPage(page + 1)}
        alt="다음"
      />
    </div>
  );
}

export default GalleryPagination;